module.exports = __webpack_public_path__ + "img/face_shape_male_extra_rect_mask.62303aa7.png";